module.exports = __webpack_public_path__ + "img/6H.24168b2f.png";